var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "append-to-body": _vm.appendToBody,
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Accrue"),
        width: "450px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "60px", "label-position": "left" } },
        [
          _c(
            "span",
            { staticStyle: { "font-size": "15px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CommissionRole")))]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", padding: "5px" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkCustoms" },
                  model: {
                    value: _vm.from.customsProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "customsProvision", $$v)
                    },
                    expression: "from.customsProvision"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CustomsProvision")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkOp" },
                  model: {
                    value: _vm.from.opProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "opProvision", $$v)
                    },
                    expression: "from.opProvision"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OperationProvision")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkOpTicket" },
                  model: {
                    value: _vm.from.opTicketProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "opTicketProvision", $$v)
                    },
                    expression: "from.opTicketProvision"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_OperationTicketProvision"))
                  )
                ]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkCsr" },
                  model: {
                    value: _vm.from.csProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "csProvision", $$v)
                    },
                    expression: "from.csProvision"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CustomerServiceProvision"))
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", padding: "5px" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkBusiness" },
                  model: {
                    value: _vm.from.businessProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "businessProvision", $$v)
                    },
                    expression: "from.businessProvision"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessProvision")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkSales" },
                  model: {
                    value: _vm.from.salesProvision,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "salesProvision", $$v)
                    },
                    expression: "from.salesProvision"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SalesProvision")))]
              )
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: { "font-size": "15px", "font-weight": "bold" } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LockLimit")))]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", padding: "5px" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "checkLockArAp" },
                  model: {
                    value: _vm.from.lockCharge,
                    callback: function($$v) {
                      _vm.$set(_vm.from, "lockCharge", $$v)
                    },
                    expression: "from.lockCharge"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "CargoMsg.Cargo_LockAccountsReceivableAndPayableEntry"
                      )
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-top": "10px" } },
            [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary", no: "1" },
                      on: { click: _vm.confirmHandler }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_Confirm")) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { no: "2" },
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_Cancel")) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }